import { render, staticRenderFns } from "./ModalEditarNoticia.vue?vue&type=template&id=5a751e52&scoped=true"
import script from "./ModalEditarNoticia.vue?vue&type=script&lang=js"
export * from "./ModalEditarNoticia.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarNoticia.vue?vue&type=style&index=0&id=5a751e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a751e52",
  null
  
)

export default component.exports